<div class="m-dialog"
     ref="baseWindow">
    <slot name="trigger"></slot>
    <portal v-if="portalCreated"
            :target-el="portalTargetSelector">
        <transition name="m--is">
            <div v-if="portalMounted"
                 v-show="propOpen"
                 class="m-dialog__wrap"
                 :class="[{ 'm--is-disabled': disabled }, className ]"
                 ref="modalWrap">
                <article class="m-dialog__article"
                         :class="{ 'm--has-width-large': hasWidthLarge }"
                         ref="article">
                    <header v-if="hasTitle"
                            class="m-dialog__header">
                        <h2>{{ title }}</h2>
                    </header>
                    <div class="m-dialog__body">
                        <div class="m-dialog__state-icon"
                             v-if="state !== 'default'">
                            <m-message class="m-dialog__state-icon__message"
                                       :state="getState"
                                       skin="page-light"></m-message>
                        </div>
                        <div v-if="hasDefaultSlot || hasMessage"
                             class="m-dialog__message">
                            <p v-if="hasMessage"
                               v-html="message"></p>
                            <slot></slot>
                        </div>
                        <div class="m-dialog__hint"
                             v-if="hasHint">
                            <div class="m-dialog__hint-body">
                                <div class="m-dialog__hint-icon">
                                    <m-icon name="m-svg__hint"
                                            size="32px"></m-icon>
                                </div>
                                <div class="m-dialog__hint-text">
                                    <span>{{ hint }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="m-dialog__footer">
                        <slot name="footer"></slot>
                        <nav class="m-dialog__footer__nav"
                             v-if="!hasFooterSlot">
                            <m-button @click="onOk()"
                                      :style="dialogStyles"
                                      :skin="okButtonSkin">
                                <template v-if="hasOkLabel">{{ okLabel }}</template>
                                <m-i18n v-else
                                        k="m-dialog:ok"></m-i18n>
                                <template v-if="hasOkPrecision"
                                          slot="precision">{{ okPrecision }}
                                </template>
                            </m-button>
                            <m-button v-if="secBtn"
                                      :style="dialogStyles"
                                      @click="onSecondaryBtn()"
                                      skin="secondary">
                                <template v-if="hasSecBtnLabel">{{ secBtnLabel }}</template>
                                <m-i18n v-else
                                        k="m-dialog:cancel"></m-i18n>
                                <template v-if="hasSecBtnPrecision"
                                          slot="precision">{{ secBtnPrecision }}
                                </template>
                            </m-button>
                            <m-link v-if="negativeLink"
                                    @click="onCancel()"
                                    mode="button">
                                <template v-if="hasCancelLabel">{{ cancelLabel }}</template>
                                <m-i18n v-else
                                        k="m-dialog:cancel"></m-i18n>
                            </m-link>
                        </nav>
                    </footer>
                </article>
            </div>
        </transition>
    </portal>
</div>
